import { create } from 'zustand';

interface CarriersListState {
  // Search
  search: string;

  // Pagination (for future use)
  page: number;
  limit: number;
}

interface CarriersListActions {
  // Search actions
  setSearch: (search: string) => void;

  // Pagination actions
  setPage: (page: number) => void;
  setLimit: (limit: number) => void;

  // Utility actions
  resetAll: () => void;
}

type CarriersListStore = CarriersListState & CarriersListActions;

const initialState: CarriersListState = {
  search: '',
  page: 1,
  limit: 100,
};

export const useCarriersListStore = create<CarriersListStore>()((set) => ({
  ...initialState,

  // Search actions
  setSearch: (search) => set({ search, page: 1 }),

  // Pagination actions
  setPage: (page) => set({ page }),
  setLimit: (limit) => set({ limit, page: 1 }),

  // Utility actions
  resetAll: () => set(initialState),
}));
